import React from 'react';
import { Button, Input, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';

const RemarkInlineEditor = ({
  itemId,
  type,
  remark,
  editingRemarkId,
  editingRemarkType,
  setEditingRemarkId,
  setEditingRemarkType,
  savingRemark,
  onSave,
}) => {
  const isEditing = editingRemarkId === itemId && editingRemarkType === type;
  const [value, setValue] = React.useState(remark || '');

  React.useEffect(() => {
    if (isEditing) {
      setValue(remark || '');
    }
  }, [isEditing, remark]);

  const handleEdit = (event) => {
    event.stopPropagation();
    setEditingRemarkId(itemId);
    setEditingRemarkType(type);
  };

  const handleCancel = (event) => {
    event.stopPropagation();
    setEditingRemarkId(null);
    setEditingRemarkType('');
  };

  const handleSave = async (event) => {
    event.stopPropagation();
    await onSave(itemId, value, type);
  };

  if (isEditing) {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
        onClick={(event) => event.stopPropagation()}
      >
        <Input.TextArea
          rows={2}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder="Enter remark"
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Tooltip title="Cancel">
            <Button
              size="small"
              shape="circle"
              icon={<CloseOutlined />}
              onClick={handleCancel}
              disabled={savingRemark}
            />
          </Tooltip>
          <Tooltip title="Save">
            <Button
              size="small"
              type="primary"
              shape="circle"
              icon={<CheckOutlined />}
              onClick={handleSave}
              loading={savingRemark}
            />
          </Tooltip>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 8,
        padding: '8px 10px',
        borderRadius: 6,
        backgroundColor: '#f7f8fa',
        color: '#8c8c8c',
        fontSize: 12,
        lineHeight: 1.5,
      }}
      onClick={(event) => event.stopPropagation()}
    >
      <div style={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }}>
        <span style={{ fontWeight: 500, color: '#7a7a7a' }}>Remark:</span>{' '}
        {remark || 'No remark'}
      </div>
      <Tooltip title="Edit">
        <Button
          size="small"
          shape="circle"
          icon={<EditOutlined />}
          onClick={handleEdit}
        />
      </Tooltip>
    </div>
  );
};

export default RemarkInlineEditor;
